import { useRef } from 'react';
import aboutUsImg from '../img/aboutus.jpg';
import { useTranslation } from "react-i18next";

export default function AboutUs({ headingLevel = 'h1' }) {
    const anchorRef = useRef(null);
    const { t } = useTranslation();
    const Heading = headingLevel;

    return(
        <div className="container" id="aboutus" ref={anchorRef}>
            <div className="homepageContent homepageContentImg">
                <div className="homepageImg">
                    <img src={aboutUsImg} alt="Igors Nikitns" />
                </div>
                <div className="homepageText">
                    <Heading>{ t('aboutus.title') }</Heading>
                    <p dangerouslySetInnerHTML={{ __html: t('aboutus.description') }} />
                </div>
            </div>
        </div>
    )
}
